import {configureStore} from '@reduxjs/toolkit';
import {reducer as loggedInUserReducer} from './loggedInUser';
import {reducer as navigationReducer} from './navigation';
import {reducer as accountsReducer} from './accounts';
import {reducer as projectsReducer} from './projects';
import {reducer as taxConfigsReducer} from './taxConfigs';
import {reducer as companiesReducer} from './companies';
import {reducer as accountSourcesReducer} from './accountSources';
import {reducer as currencyRatesReducer} from './currencyRates';

export const store = configureStore({
    reducer: {
        loggedInUser: loggedInUserReducer,
        navigation: navigationReducer,
        accounts: accountsReducer,
        projects: projectsReducer,
        taxConfigs: taxConfigsReducer,
        companies: companiesReducer,
        accountSources: accountSourcesReducer,
        currencyRates: currencyRatesReducer,
    },
});
